module.exports = __webpack_public_path__ + "img/undraw_Online_article_re_daq5.93b046e2.svg";